export default __webpack_public_path__ + "static/media/Gloves of Red Ruin.0ad4cc82.jpg";